import { path } from "ramda";
import { apiSauce } from "../sagas/";
import ModalUtil, { findErrorMessage } from "../util/modal";
import OrganizationAction from "../reducers/OrganizationReducer";
import { ArrayUtil } from "../util/index";
import InfoErrorStatus from "../constants/errorStatus";
import { getToken, getCorpId, fetchHandler, buildDatePayload, buildCompareDatePayload, mergePayloadByFilter } from "../util/actions";
import I18n from "../i18n";
import Store, { ReducerKeys } from "../reducers";
import { StressTestMockup, CounselingMockup, IndividualUserMockup } from "../_mockup/index";

//region Stress
const fetchStressQuestionAndAnswer = ({
	dateRange
}) => new Promise((resolve, reject) => {
	const payload = ArrayUtil.isAliveArray(dateRange) ? {
		start: dateRange[0].unix(), end: dateRange[1].unix()
	} : undefined;
	fetchHandler(apiSauce.fetchStressQuestionAndAnswer, ["data", "data"], payload, resolve, reject);
});

const fetchStressChoice = ({
	dateRange, questionIndex = 0, choiceIndex = 0, errorOnInfo = true
}) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	payload["question_index"] = questionIndex;
	payload["choice_index"] = choiceIndex;
	fetchHandler(apiSauce.fetchStressChoice, ["data"], payload, resolve, reject, errorOnInfo);
});

const fetchStressLevel = ({ dateRange }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchStressLevel, ["data"], payload, resolve, reject);
});
const fetchStressCategory = ({ dateRange, category }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	payload["category"] = category;
	// const mockupTotal = [
	// 	{id:-1,count:5},
	// 	{id:91,count:5},
	// 	{id:92,count:5}
	// ];
	// for(let i=0;mockupTotal.length<10;i++){
	// 	mockupTotal.push({id:-1, count:5});
	// }
	// console.log("mockupTotal: ",mockupTotal);
	// resolve({total:mockupTotal});
	fetchHandler(apiSauce.fetctStressCategory, ["data"], payload, resolve, reject);
});
const fetchStressReturning = ({ dateRange }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchStressReturning, ["data"], payload, resolve, reject);
});

const fetchStressOverview = ({dateRange, errorOnInfo = true}) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchStressOverview, ["data"], payload, resolve, reject, errorOnInfo);
});

const fetchStressAge = ({ dateRange }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchStressAge, ["data"], payload, resolve, reject);
});
const fetchStressGender = ({ dateRange }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchStressGender, ["data"], payload, resolve, reject);
});

const exportStressExcel = ({ dateRange })=> new Promise((resolve, reject)=>{
	const payload = buildDatePayload(dateRange);
	const packPayload = { headers: { token: getToken(), organization: getCorpId()}, payload };
	apiSauce.exportStressExcel(packPayload).then(res=>{
		const { status, ok, data, problem } = res;
		if(status === 200 && ok && data.success){
			resolve(data);
		}else{
			reject(problem);
		}
	});
});
//endregion

//region People
const fetchPeopleOverview = (payload) => new Promise((resolve) => {
	const packPayload = { headers: { token: getToken(), organization: getCorpId() }, payload };
	try {
		Store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.fetchPeopleOverview(packPayload).then((res) => {
			const data = path(["data"], res);
			if (res.ok && data) {
				Store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(data);
			} else {
				Store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(null);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		Store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(null);
	}
});

const fetchPeople = (id, payload = {}) => new Promise((resolve) => {
	const packPayload = { id, payload, headers: { token: getToken(), organization: getCorpId() } };
	try {
		Store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.fetchPeople(packPayload).then(res => {
			const data = path(["data"], res);
			// console.log("boboboboobob", data);
			if (res.ok && data) {
				Store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(data);
			} else {
				Store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(null);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		Store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(null);
	}
});
//endregion

//region Counseling
const fetchCounOverview = ({ dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchCounOverview, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounGender = ({ dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchCounGender, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounProvider = ({ dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchCounProvider, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounPlatform = ({ dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchCounPlatform, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounTopic = ({ dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchCounTopic, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounAge = ({ dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchCounAge, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounReturning = ({ dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchCounReturning, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounFeedback = ({ dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchCounFeedback, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounVisitOutcome = ({ dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	fetchHandler(apiSauce.fetchCounVisitOutcome, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounCategory = ({ category, dateRange, errorOnInfo = true }) => new Promise((resolve, reject) => {
	const payload = buildDatePayload(dateRange);
	payload["category"] = category;
	fetchHandler(apiSauce.fetchCounCategory, ["data"], payload, resolve, reject, errorOnInfo);
});
//endregion

//region Filter
const fetchStressSelectByFilter = ({dateRange, filters, errorOnInfo = true})=> new Promise((resolve,reject)=>{
	let payload = buildDatePayload(dateRange);
	payload = mergePayloadByFilter(payload, filters);
	// resolve(StressTestMockup[Math.random() >= 0.5 ? "primary" : "secondary"]);
	fetchHandler(apiSauce.fetchStressSelectByFilter, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchStressIndividualByFilter = ({dateRange, filters, errorOnInfo = true})=> new Promise((resolve,reject)=>{
	let payload = buildDatePayload(dateRange);
	payload = mergePayloadByFilter(payload, filters);
	// resolve(IndividualUserMockup[Math.random() >= 0.5 ? "primary" : "secondary"]);
	fetchHandler(apiSauce.fetchStressIndividualByFilter, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounSelectByFilter = ({dateRange, filters, errorOnInfo = true})=> new Promise((resolve,reject)=>{
	let payload = buildDatePayload(dateRange);
	payload = mergePayloadByFilter(payload, filters);
	// resolve(CounselingMockup[Math.random() >= 0.5 ? "primary" : "secondary"]);
	fetchHandler(apiSauce.fetchCounSelectByFilter, ["data"], payload, resolve, reject, errorOnInfo);
});
const fetchCounIndividualByFilter = ({dateRange, filters, errorOnInfo = true})=> new Promise((resolve,reject)=>{
	let payload = buildDatePayload(dateRange);
	payload = mergePayloadByFilter(payload, filters);
	// resolve(IndividualUserMockup[Math.random() >= 0.5 ? "primary" : "secondary"]);
	fetchHandler(apiSauce.fetchCounIndividualByFilter, ["data"], payload, resolve, reject, errorOnInfo);
});
const exportStressFilterExcel = ({dateRange, filters, errorOnInfo = true})=> new Promise((resolve,reject)=>{
	const { primary, secondary } = dateRange;
	let payload = buildCompareDatePayload(primary, secondary);
	payload = mergePayloadByFilter(payload, filters);
	fetchHandler(apiSauce.exportStressFilterExcel, undefined, payload, resolve, reject, errorOnInfo, {isFile:true});
});
const exportCounFilterExcel = ({dateRange, filters, errorOnInfo = true})=> new Promise((resolve,reject)=>{
	const { primary, secondary } = dateRange;
	let payload = buildCompareDatePayload(primary, secondary);
	payload = mergePayloadByFilter(payload, filters);
	fetchHandler(apiSauce.exportCounFilterExcel, undefined, payload, resolve, reject, errorOnInfo, {isFile:true});
});
//endregion

//region Export
export default {
	fetchStressQuestionAndAnswer,
	fetchStressChoice,
	fetchStressLevel,
	fetchStressCategory,
	fetchStressReturning,
	fetchStressOverview,
	fetchStressAge,
	fetchStressGender,
	exportStressExcel,

	fetchPeopleOverview,
	fetchPeople,

	fetchCounOverview,
	fetchCounGender,
	fetchCounProvider,
	fetchCounPlatform,
	fetchCounTopic,
	fetchCounAge,
	fetchCounReturning,
	fetchCounFeedback,
	fetchCounVisitOutcome,
	fetchCounCategory,

	fetchStressSelectByFilter,
	fetchStressIndividualByFilter,
	fetchCounSelectByFilter,
	fetchCounIndividualByFilter,

	exportStressFilterExcel,
	exportCounFilterExcel,
};
//endregion


// WEBPACK FOOTER //
// ./src/actions/ReportAction.js